<template lang="pug">
  .component-tabbed-client-wallets
    ActionBar
      h2(slot="title") Billing
      AddCommonCostToWallet(slot="action", :wallet="selectedWallet.id")
      //

    .tabs-inner-content
      .row
        .column
          .wallets.card
            .wallet(v-for="(wallet,id) in wallets", @click="setActive(id)", :class="{selected:selectedIndex === id}")
              .wallet-info
                div W{{wallet.id}} {{wallet.name}}
                div
                  template(v-if="wallet.payment_method !== null")
                    span PM{{wallet.payment_method.id}}
                      small {{wallet.payment_method.name}}
                  template(v-else)
                    small NO PAYMENT METHOD ASSOCIATED WITH THIS WALLET
                h3 {{ $priceWithcurrency(wallets[id].amounts['BALANCE_VATIN']) }}
              .wallet-actions(v-if="selectedIndex === id")
                ActionButton(:action="billWallet", :button="false", v-if="$acl('run-command-console')")
                  .fa.fa-money(style="color:white")
                .fa.fa-pencil(@click="editWallet")
      .container
        .row
          .column
            BackofficeMultiWallet(ref="wrList", v-model="selectedWallet")
          .column
            TabbedClientInvoices(ref="inList", v-if="selectedWallet", :wallet="selectedWallet")
        .row
          .column
            TabbedPacketRecords
          .column
            TabbedClientDeposits(ref="dpList")
        .row
          .column
            TabbedCreditRecords(ref="crList", type="Promo")
          .column
            TabbedPaidCreditRecords(ref="crList", type="Paid")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BackofficeWalletRecord from '../WalletRecord'
  import PaymentMethod from '../PaymentMethod'
  import WalletAddCost from '../WalletAddCost.vue'
  import WalletEdit from '../smartedits/WalletEdit.vue'
  import BaseList from '../../../pages/backoffice/BaseList'
  import BackofficeMultiWallet from './MultiWallet'
  import TabbedClientInvoices from './ClientInvoices'
  import TabbedCreditRecords from './CreditRecords'
  import MaggieHelper from '../../../maggieHelper'
  import TabbedClientPaymentMethods from './ClientPaymentMethods'
  import TabbedClientDeposits from './ClientDeposits'
  import ActionButton from '../../structure/ui/ActionButton'
  import ClientTopUps from './ClientTopUps'
  import ActionBar from '../../structure/ui/ActionBar'
  import CommonCostButtonModal from '../../structure/ui/actions/CommonCostButtonModal'
  import AddCommonCostToWallet from '../../structure/ui/actions/AddCommonCostToWallet'
  import TabbedPaidCreditRecords from './PaidCreditRecords'
  import TabbedPacketRecords from "./PacketRecords";

  export default {
    name: 'TabbedClientWallets',
    components: {
      TabbedPacketRecords,
      TabbedPaidCreditRecords,
      AddCommonCostToWallet,
      CommonCostButtonModal,
      ActionBar,
      ClientTopUps,
      ActionButton,
      TabbedClientDeposits,
      TabbedClientPaymentMethods,
      TabbedCreditRecords,
      TabbedClientInvoices,
      BackofficeMultiWallet,
      BaseList,
      WalletEdit,
      WalletAddCost,
      PaymentMethod,
      BackofficeWalletRecord,
    },
    data() {
      return {
        wallets: [],
        paymentMethods: [],
        selectedIndex: 0,
        selectedWallet: null,
      }
    },
    created() {
      this.loadWallet()
      KeplerBackofficeSdk.clients.list(1, 1000, {id: this.$route.params.id}).paymentMethods((data) => {
        this.paymentMethods = data.items
      })
    },
    methods: {
      editWallet() {
        var pm = []
        this.paymentMethods.forEach((item) => {
          pm.push(item.name)
        })
        MaggieHelper.openRightPanel({
          component: WalletEdit,
          props: {
            item: this.selectedWallet,
            paymentMethodList: pm,
            paymentMethods: this.paymentMethods,
          }
        })
      },
      loadWallet() {
        KeplerBackofficeSdk.clients.list(1, 1000).wallets(this.$route.params.id, (data) => {
          this.wallets = data
          data.forEach((item, key) => {
            if (item.default) {
              this.selectedIndex = key
              this.selectedWallet = item
            }
          })

        })
      },
      setActive(index) {
        this.selectedIndex = index
        this.selectedWallet = this.wallets[this.selectedIndex]
      },
      billWallet() {
        const c = `kepler:bill-wallet wallet-id:${this.selectedWallet.id}`
        return KeplerBackofficeSdk.console.run(c, (ok) => {
          this.loadWallet()
        })
      },
    },
    computed: {},
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-client-wallets
    // TODO fix for mobile... (i will forget for sure)
    //.row
    //  margin: 0
    //  padding: 0
    //.tabs-inner-content
    //  padding: 0
    //.column
    //  padding: 0

    .wallets
      display: flex
      flex-direction: row
      flex-wrap: wrap

      .wallet
        display: flex
        justify-content: space-between
        flex: 1 0 21%
        margin: 0.1em
        padding: 0.5em 1em
        border-radius: 5px
        cursor: pointer
        max-width: 400px
        flex-basis: content
        flex-grow: 1
        border: 1px solid #cacaca
        background: white

        .wallet-actions
          display: flex
          flex-direction: row

          .fa
            font-size: 1.2em

          .component-action-button
            button
              height: 0
              padding: 0

          *
            margin: 0 0.1em

        &.selected
          background: #5EB9CF
          border: none
          color: white

          h3
            color: white

  // flex-basis: 0
</style>



// WEBPACK FOOTER //
// ClientWallets.vue?736840ad